// App.js
import React, { useState, useEffect, use } from 'react';
import {
    ThemeProvider,
    CssBaseline,
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Modal,
    Paper,
    Typography,
    Container,
    CircularProgress,
    Button
} from '@mui/material';
import {
    Home,
    Add,
    AccountCircle,
    Login,
    Logout,
    Search
} from '@mui/icons-material';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useNavigate
} from 'react-router-dom';

// Import theme and components
import theme from './theme';
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import SubmitDataForm from './components/SubmitDataForm';
import AccountPage from './components/AccountPage';
import LoginPage from './components/LoginPage';
import Footer from './components/Footer';
import SearchResults from './components/SearchResults';
import { DarkModeProvider } from './themeContext';

// ProtectedRoute component
const ProtectedRoute = ({ user, children }) => {
    return user?.token ? children : <Navigate to="/login" replace />;
};

const isLoggedIn = () => {
    return localStorage.getItem('token')
}


// Logout Handler component
const LogoutHandler = ({ setUser }) => {
    const navigate = useNavigate();
    useEffect(() => {
        localStorage.clear();
        setUser({ token: null, id: null, name: '', email: '' });
        navigate('/');
    }, [setUser, navigate]);
    return null;
};

function App() {
    const [modalMessage, setModalMessage] = useState('');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [user, setUser] = useState({
        token: localStorage.getItem('token') || null,
        id: localStorage.getItem('user_id') || null,
        name: localStorage.getItem('name') || '',
        email: localStorage.getItem('email') || ''
    });
    const [isDark, setIsDark] = useState(false);

    const navItems = [
        { id: '/', label: 'Home', icon: <Home /> },
        { id: '/submit', label: 'Submit Data', icon: <Add /> },
        {id: '/search', label: 'Search', icon: <Search />},
        // { id: '/account', label: 'Account', icon: <AccountCircle /> },
        // { id: '/login', label: 'Login', icon: <Login /> },
        // { id: '/logout', label: 'Log Out', icon: <Logout /> }
    ];

    if (!isLoggedIn()) {
        navItems.push({id: '/login', label: 'Login', icon: <Login />})
    } else {
        navItems.push({ id: '/account', label: 'Account', icon: <AccountCircle /> });
        navItems.push({id: '/logout', label: 'Log Out', icon: <Logout />});
    }

    useEffect(() => {
    document.documentElement.classList.toggle("dark-mode", isDark);
    }, [isDark]);



    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* <DarkModeProvider> */}
            {/* <button onClick={() => setIsDark(!isDark)}>
            {isDark ? "Light Mode" : "Dark Mode"}
            </button> */}
            <Router>
                <Navigation
                    currentPage={window.location.pathname}
                    setCurrentPage={(page) => window.location.href = page}
                    onMenuClick={() => setIsMobileMenuOpen(true)}
                    userId={user.id}
                />

                <Drawer
                    anchor="left"
                    open={isMobileMenuOpen}
                    onClose={() => setIsMobileMenuOpen(false)}
                >
                    <Box
                        sx={{ width: 250 }}
                        role="presentation"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        <List>
                            {navItems.map((item) => (
                                <ListItem key={item.id} disablePadding>
                                    <ListItemButton onClick={() => window.location.href = item.id}>
                                        <ListItemIcon>{item.icon}</ListItemIcon>
                                        <ListItemText primary={item.label} />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Drawer>

                <Box component="main">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/login" element={<LoginPage setUser={setUser} />} />
                        <Route path="/search" element={
                            <ProtectedRoute user={user}>
                                <SearchResults user={user} />
                            </ProtectedRoute>
                        } />
                        <Route path="/submit" element={
                            <ProtectedRoute user={user}>
                                <SubmitDataForm setModalMessage={setModalMessage} user={user} />
                            </ProtectedRoute>
                        } />
                        <Route path="/account" element={
                            <ProtectedRoute user={user}>
                                <AccountPage user={user} />
                            </ProtectedRoute>
                        } />
                        <Route path='/search' element={
                            <ProtectedRoute user={user}>
                                <SearchResults user={user}/>
                            </ProtectedRoute>
                        } />

                        <Route path="/logout" element={<LogoutHandler setUser={setUser} />} />
                        <Route path="*" element={<Typography variant="h6" sx={{ m: 4 }}>Page Not Found</Typography>} />
                    </Routes>
                </Box>

                <Modal open={!!modalMessage} onClose={() => setModalMessage('')}>
                    <Paper sx={{ p: 4, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: '90%', sm: 400 }, borderRadius: 2 }}>
                        <Typography variant="h6">{modalMessage}</Typography>
                        <Button onClick={() => setModalMessage('')} sx={{ mt: 2 }}>Close</Button>
                    </Paper>
                </Modal>

                <Footer setCurrentPage={(page) => window.location.href = page} />
            </Router>
            {/* </DarkModeProvider> */}
        </ThemeProvider>
    );
}

export default App;
